var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Box } from "@material-ui/core";
import CardItem from "../commons/CardItem/CardItem";
import { usePaymentMethod } from "./state/usePaymentMethods";
import { PAYMENT_IMGS, PaymentMethodsImgEnum, } from "../../shared/constants/PaymentMethodImgEnum";
import { PAYMENT_METHOD_CONFIG } from "../../shared/constants/PaymentMethodEnum";
import { useCheckoutContext } from "../../context/useCheckoutContext";
export var PaymentMethods = function () {
    var _a = usePaymentMethod(), paymentMethodsList = _a.paymentMethodsList, _b = _a.handlers, getSectionRedirection = _b.getSectionRedirection, getKpayRedirection = _b.getKpayRedirection, readOnly = _a.readOnly;
    var enableKpay = useCheckoutContext().enableKpay;
    return (React.createElement(Box, null,
        enableKpay && (React.createElement(CardItem, { title: "itemTitles.fastPay", logo: PAYMENT_IMGS[PaymentMethodsImgEnum.KPAY], description: "itemDescriptions.makePaymentsKpay", handlerOnClick: function () { return !readOnly && getKpayRedirection(); } })),
        paymentMethodsList.map(function (paymentMethod, index) {
            return (React.createElement(CardItem, __assign({ key: index }, PAYMENT_METHOD_CONFIG[paymentMethod], { handlerOnClick: function () { return getSectionRedirection([paymentMethod]); } })));
        })));
};
